export default "__VITE_ASSET__2FLp0xsq__"